import { useRef, useState } from "react";
import IconsEnum from "../../classes/enums/IconsEnum";
import useTranslation from "../../hooks/i18n/useTranslation";
import DateRangePicker from "../datepicker/DateRangePicker";
import IconButton from "../iconButton/IconButton";
import TextBox from "../textBox/TextBox";

import "./FilterAndActionBar.css";

const FilterAndActionBar = ({
  onSearch,
  onDateRangeChange,
  onClear,
  onAdd,
  value = "",
  searchPlaceholder,
}) => {
  const { t } = useTranslation();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const dateRangePickerRef = useRef();

  const handleSearch = e => {
    onSearch(e.target.value);
  };

  const handleClear = () => {
    if (
      dateRangePickerRef.current &&
      dateRangePickerRef.current.clearDateRange
    ) {
      dateRangePickerRef.current.clearDateRange();
    }
    onClear();
  };

  const handleDateRangeChange = (start, end) => {
    onDateRangeChange(start, end);
  };

  return (
    <div className="search-filter-container">
      <div className="search-bar-container">
        <IconButton
          onClick={handleClear}
          icon={IconsEnum.CLEARFILTER}
          noBgColor
          title={t("183")}
        />
        <TextBox
          placeholder={searchPlaceholder || t("5")}
          value={value}
          onChange={handleSearch}
        />

        <div className="import-button-container">
          <IconButton
            onClick={setShowDatePicker.bind(null, !showDatePicker)}
            icon={IconsEnum.CALENDAR}
            noBgColor
            title={t("426")}
          />
          {onAdd && (
            <IconButton
              onClick={onAdd}
              icon={IconsEnum.ADD}
              noBgColor
              title={t("1")}
            />
          )}
        </div>
      </div>
      {showDatePicker && (
        <div className="calendar-container">
          <DateRangePicker
            ref={dateRangePickerRef}
            onDateRangeChange={handleDateRangeChange}
          />
        </div>
      )}
    </div>
  );
};

export default FilterAndActionBar;
